<script>
	import Collector from '../Models/Scripture/Collector';
	import Data from '../States/Data';
	import Helper from '../Models/Helper';
	import Scripture from '../Models/Scripture';

	let name = '';
	let link = '#';
	let logo = false;
	let verses = [];

	function clean() {
		jQuery('html').addClass('popup');
	}

	async function load() {
		const search = window.location.search;
		const params = new URLSearchParams(search);
		name = params.get('name');
		link = params.get('link');
		logo = /^(1|true)$/i.test(params.get('logo'));

		const reference = await Scripture.reference(name);
		const list = versesByReference(reference);

		const collector = new Collector();
		const structure = await collector.collect(list);
		verses = structure.length ? structure[0].verses : [];
	}

	function versesByReference(reference) {
		const list = [];
		const base = `${reference.book}_${reference.chapter}`;
		for (let verse of reference.verses)
			list.push(`${base}_${verse}`);

		return list;
	}

	async function init() {
		clean();
		await Data.init();
		await load();
	}

	init();
</script>

<style>
	div.popup {
		line-height: 1.75em;
		padding: .1em .5em;
	}

	h1 {
		font-size: 1.15em;
	}

	div.scripture {
		margin-bottom: 1em;
	}

	div.scripture div {
		display: inline;
	}

	div.scripture span {
		display: inline-block;
		font-weight: bold;
		padding-left: .25em;
		opacity: .5;
	}

	div.footer {
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-direction: row;
	}

	div.footer a {
		padding: .3em 3em .25em 3em;
		margin: 0;
		border-radius: .3em;
		background: hsla(0, 0%, 0%, .1);
	}

	div.footer img {
		max-width: 10em;
	}
</style>

<div class="popup">
	<h1>
		<a href="{link}" target="_blank">{name}</a>
	</h1>
	{#if Helper.is(verses)}
		<div class="scripture">
			{#each verses as verse}
				<div><span>{verse.reference.verses[0]}</span> {@html verse.scripture}</div>
			{/each}
		</div>
		<div class="footer">
			<a href="{link}" class="button" target="_blank">Lees verder</a>
			{#if logo}
				<img src="./media/logo/BB/light.svg" alt="Logo"/>
			{/if}
		</div>
	{/if}
</div>